/**
 * v-model定制
 * author xxk
 * https://cn.vuejs.org/v2/guide/components-custom-events.html#自定义组件的-v-model
 */
/**
 * 获取v-model混入方法
 * @param prop：设置v-model的属性名，同时在props选项中声明参数
 * @param event：设置v-model的事件名
 * @param propValue：props选项里声明prop的设置
 * @propModel：子组件通过修改propModel来改prop参数
 * @returns {{computed: {}, model: {prop, event}, props: {}}|*}：
 */
const getModelMixin = (
    {
        prop,
        event = 'change',
        propValue = {},
        propModel = `${prop}Model`,
    } = {},
) => {
    return {
        model: { prop, event },
        props: {
            [prop]: propValue,
        },
        computed: {
            [propModel]: {
                get() { return this[prop]; },
                set(value) { this.$emit(event, value); },
            },
        },
    };
};
// 弹窗类组件用：show属性双v-model中转
const vModel = getModelMixin({
    prop: 'value',
    propValue: { type: [String,Number,Array,Boolean], default: '' },
});
// 导出
export {
    // 常用属性导出
    vModel,
    // 方法导出
    getModelMixin,
};
